import React from 'react'
import MainLayout from '@layouts/main-layout'
import ContactUs from '@components/contact-us'

const ContactUsPage = () => {
  return (
    <>
      <ContactUs />
    </>
  )
}

ContactUsPage.getLayout = (page: React.ReactElement) => {
  return <MainLayout>{page}</MainLayout>
}

export default ContactUsPage
